
import { defineComponent, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import { useRouter, useRoute } from 'vue-router'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'

import LayoutsGuest from '@/layouts/Guest.vue'
import BaseShadowCard from '@/components/BaseShadowCard.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import { ALERT_COLORS } from '@/store/base'

export default defineComponent({
  components: { LayoutsGuest, BaseShadowCard, BaseFormSubmit },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const btnDisabled = ref(false)
    const email = ref('')

    const schema = yup.object({
      password: yup.string().required().min(8).max(255),
      password_confirmation: yup.string().required().oneOf([yup.ref('password'), null], t('validation.password_confirmation')),
    })
    const { handleSubmit, errors } = useForm({ validationSchema: schema })
    const { value: password } = useField<string>('password')
    const { value: password_confirmation } = useField<string>('password_confirmation')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/first/change-password', {
          ...values,
          token: route.params.token
        })
        .then(() => {
          store.commit('base/setAlertMessages', { messages: ['ログインパスワードを設定しました。'], persistent: true, color: ALERT_COLORS.info })
          router.push('/login')
        })
        .finally(() => btnDisabled.value = false)
    })

    onMounted(() => {
      email.value = window.atob(route.query.email as string)
    })

    return {
      t,
      errors,
      password,
      password_confirmation,
      onSubmit,
      btnDisabled,
      email
    }
  },
})
